import SettingsHeader from './SettingsHeader.jsx';

export default SettingsHeader;
